import {Injectable} from '@angular/core';
import {CHAT_FRAME_COMMANDS} from "../model/chatFrame-commands";

@Injectable({
  providedIn: 'root'
})
export class ChatFrameService {
  commands = CHAT_FRAME_COMMANDS;
  constructor() {}

  sendMessage(message) {
    parent.postMessage(message,"*");
  }

  increaseFrameHeight() {
    this.sendMessage(this.commands.increaseHeight);
  }

  decreaseFrameHeight() {
    this.sendMessage(this.commands.decreaseHeight);
  }

}
